// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.textarea {
  background-color: var(--color-input-background);
  color: var(--color-content-base);
  box-shadow: 0 0 0 1px var(--color-border-base), 0px -1px 1px var(--color-border-base);
  line-height: 32px;
  font-size: 14px;
  font-weight: 400;
  border-radius: 4px;
  border: none;
  height: 32px;
  padding: 0 5px;
  height: unset;
  min-height: 24px;
}
.textarea--disabled {
  opacity: 0.5;
}
.textarea--plain {
  box-shadow: none;
}
.textarea--hide-arrows::-webkit-outer-spin-button,
.textarea--hide-arrows::-webkit-inner-spin-button {
  -webkit-appearance: none;
  /* Chrome & Safari */
}
.textarea--hide-arrows[type=number] {
  -moz-appearance: textfield;
  /* Firefox */
}
.textarea--error {
  box-shadow: 0 0 0 1px var(--color-error-shadow-base), 0px -1px 1px var(--color-error-shadow-base);
  background-color: var(--color-error-background-base);
}
.textarea--variant-small {
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
}
.textarea--variant-medium {
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
}
.textarea--variant-large {
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
}
.textarea--focused,
.textarea:focus {
  outline-offset: 2px;
  outline: 2px solid var(--color-outline-base);
}
.textarea--resize-none {
  resize: none;
}
.textarea--resize-vertical {
  resize: vertical;
}
.textarea--resize-horizontal {
  resize: horizontal;
}
.textarea--resize-both {
  resize: both;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/common/ui/form-inputs/Textarea.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/input.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/misc.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;ECCE,+CAAA;EACA,gCAAA;EACA,qFAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EAGE,cAAA;EDVF,aAAA;EACA,gBAAA;AAkBF;ACNE;EACE,YAAA;ADQJ;ACLE;EACE,gBAAA;ADOJ;ACHI;;EAEE,wBAAA;EDKJ,oBAAoB;AACtB;ACHI;EACE,0BAAA;EDKJ,YAAY;AACd;ACFE;EACE,iGAAA;EACA,oDAAA;ADIJ;ACDE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADGJ;ACAE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADEJ;ACCE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADCJ;ACEE;;EC1DA,mBAAA;EACA,4CAAA;AF4DF;AAvDE;EACE,YAAA;AAyDJ;AAtDE;EACE,gBAAA;AAwDJ;AArDE;EACE,kBAAA;AAuDJ;AApDE;EACE,YAAA;AAsDJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.textarea {\n  .neptune-input();\n  height: unset;\n  min-height: 24px; // input line-height (22px) + border (1px)\n\n  &--resize-none {\n    resize: none;\n  }\n\n  &--resize-vertical {\n    resize: vertical;\n  }\n\n  &--resize-horizontal {\n    resize: horizontal;\n  }\n\n  &--resize-both {\n    resize: both;\n  }\n}\n","@import \"./../variables.less\";\n\n.neptune-input(@with-padding: true) {\n  background-color: var(--color-input-background);\n  color: var(--color-content-base);\n  box-shadow: @input-box-shadow;\n  line-height: 32px;\n  font-size: @fontSize-sm;\n  font-weight: @fontWeight-regular;\n  border-radius: @input-border-radius;\n  border: none;\n  height: 32px;\n\n  & when (@with-padding = true) {\n    padding: 0 5px;\n  }\n\n  &--disabled {\n    opacity: 0.5;\n  }\n\n  &--plain {\n    box-shadow: none;\n  }\n\n  &--hide-arrows {\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none; /* Chrome & Safari */\n    }\n\n    &[type=number] {\n      -moz-appearance: textfield; /* Firefox */\n    }\n  }\n\n  &--error {\n    box-shadow: @input-box-shadow-error;\n    background-color: @input-bg-error;\n  }\n\n  &--variant-small {\n    height: @layoutUnit-lg;\n    line-height: @layoutUnit-lg;\n    border-radius: 4px;\n  }\n\n  &--variant-medium {\n    height: @layoutUnit-xl;\n    line-height: @layoutUnit-xl;\n    border-radius: 4px;\n  }\n\n  &--variant-large {\n    height: @layoutUnit-xxl;\n    line-height: @layoutUnit-xxl;\n    border-radius: 4px;\n  }\n\n  &--focused,\n  &:focus {\n    .n-outline();\n  }\n}\n\n.neptune-input-select() {\n  .neptune-input(@with-padding: false);\n\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n\n  user-select: none;\n\n  padding: 6px 8px;\n\n  &[data-placeholder] {\n    color: var(--color-content-secondary);\n  }\n\n  &__icon {\n    color: var(--color-content-secondary);\n  }\n}\n",".n-outline() {\n  outline-offset: 2px;\n  outline: 2px solid var(--color-outline-base);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
